export default __webpack_public_path__ + "static/media/p77.558f928c.jpg";